import { Modal, message } from "antd";

const errorModal = (content, onOk) => {
  Modal.success({ title: "Created", content, onOk });
};

export default errorModal;
